"use strict";
exports.__esModule = true;
exports.toLatLong = void 0;
var srs_1 = require("../../srs");
var transform_1 = require("./transform");
var toLatLong = function (point) { return (0, transform_1.transform)(point, srs_1.DEFAULT_SRS.code); };
exports.toLatLong = toLatLong;
//# sourceMappingURL=toLatLong.js.map